import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { campaignAdFromServer, getCampaignAdsQuery } from 'models/campaign-ads-model'
import { get, put } from 'utils/http'

// Campaign ads list (self-fetches now — removed from the fetchCampaign fan-out).
export const useCampaignAds = (id: any, meta: any) =>
  useQuery({
    queryKey: ['campaignAds', id, meta],
    queryFn: async () => {
      const { count, ads } = await get<{ count: number; ads: any[] }>(`/management/campaigns/${id}/ads`, {
        query: getCampaignAdsQuery(meta),
      })
      return { count, items: (ads || []).map(campaignAdFromServer) }
    },
    enabled: !!id,
  })

// Toggle a banner's running status, then refetch (was an optimistic patchSingleById).
export const useUpdateAdStatus = () => {
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()
  return useMutation({
    mutationFn: ({ campaignId, ad }: any) =>
      put(`/management/campaigns/${campaignId}/banners/${ad.type}/${ad.id}/status`, { IsActive: ad.is_running }),
    onSuccess: (_d, { campaignId }: any) => queryClient.invalidateQueries({ queryKey: ['campaignAds', campaignId] }),
    onError: () => addNotification('Ad status update error', 'error'),
  })
}
